import { render, staticRenderFns } from "./ColorHeader.vue?vue&type=template&id=9b8b1494&scoped=true&"
import script from "./ColorHeader.vue?vue&type=script&lang=js&"
export * from "./ColorHeader.vue?vue&type=script&lang=js&"
import style0 from "./ColorHeader.vue?vue&type=style&index=0&id=9b8b1494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8b1494",
  null
  
)

export default component.exports